import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash'

import I18n from 'PMT/i18n/I18n';

// -- constants
import Events from 'constants/Events';
import RoutingEnum from 'constants/RoutingEnum';

// -- utils
import { ViewUtils } from 'PMT/utils';
import Listener from 'PMT/flux/Listener';

// -- actions
import RouteAction from 'actions/RouteAction';
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- stores
import SessionStore from 'stores/SessionStore';
import {OrderSettingsStore, RestaurantMenuStore, RestaurantStore} from 'stores';

// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import Menu from 'PMT/entities/menu/Menu';

// -- components
import RestaurantMenuTabs from "pages/menu/RestaurantMenuTabs";
import AbstractComponent from 'components/AbstractComponent';
import Ariane from 'PMT/components/Ariane';
import MenuDetailView from './MenuDetailView';

class MenuDetailPage extends AbstractComponent {

  state = {
    restaurantMenu: RestaurantMenuStore.getRestaurantMenu(),
    restaurant: RestaurantStore.getRestaurant(),
    menu: null,
    apiError: null
  };

  componentDidMount() {
    RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

    if (_.isNull(this.state.restaurantMenu)) {
      RestaurantMenuAction.loadRestaurantMenu();
    } else {
      this.loadMenu();
    }
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
  }

  get restaurantMenuStoreListeners(): Array<Listener> {
    return [
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange),
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onMenuUpdated),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_MENU_SUCCESS, this.onMenuUpdated),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_MENU_ERROR, this.onError),
      new Listener(Events.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_SUCCESS, this.onMenuUpdated),
      new Listener(Events.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_ERROR, this.onError)
    ];
  }

  get menu(): Menu {
    return this.state.menu;
  }

  get restaurant(): Restaurant {
    return this.state.restaurant;
  }

  get restaurantMenu(): RestaurantMenu {
    return this.state.restaurantMenu;
  }

  getMenuOnRestaurantMenu(restaurantMenu) {
    const menuId = this.props.match.params.menuId;
    const menu: Menu = restaurantMenu.getMenuWithId(menuId);

    return menu;
  }

  loadMenu() {
    const menu: Menu = this.getMenuOnRestaurantMenu(this.state.restaurantMenu);
    this.setState({
      menu,
      loading: false
    });
  }

  // -- Event functions

  onChange = () => {
    const restaurantMenu: RestaurantMenu = RestaurantMenuStore.getRestaurantMenu();
    const menu: Menu = this.getMenuOnRestaurantMenu(restaurantMenu);

    this.setState({
      restaurantMenu,
      menu,
      loading: false
    });
  };

  onMenuUpdated = () => {
    const restaurantMenu: RestaurantMenu = RestaurantMenuStore.getRestaurantMenu();
    const menu: Menu = this.getMenuOnRestaurantMenu(restaurantMenu);

    this.setState({
      restaurantMenu,
      menu,
      loading: false
    });
  };

  onError = () => {
    this.setState({
      apiError: RestaurantMenuStore.getApiError()
    });
  };

  onUpdate = (menu: Menu, image) => {
    this.showLoading();
    const imageFile = _.isNull(image) ? null : ViewUtils.dataUriToFile(image);
    RestaurantMenuAction.saveMenu(menu, imageFile);
  };

  onImageRemove = (menu: Menu) => {
    this.showLoading();
    RestaurantMenuAction.deleteMenuImage(menu);
  }

  // -- renderers

  renderBody() {
    if (!_.isNull(this.apiError)) {
      return this.renderApiErrorBlock();
    } else if (_.isNull(this.state.menu)) {
      return this.renderOnLoadingContent();
    }

    return (
      <MenuDetailView
        menu={this.menu}
        currencyCode={this.restaurant.currency}
        restaurantMenu={this.restaurantMenu}
        onUpdate={this.onUpdate}
        onImageRemove={this.onImageRemove}
        orderSettings={OrderSettingsStore.getOrderSettings()}
      />
    );
  }

  render() {
    const arianeIcon = 'fa-shopping-cart';

    const arianeDetails = [
      {
        name: I18n.tr('menu.order'),
        link: null
      },
      {
        name: I18n.tr('menu.order.restaurant_menu'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.CATEGORIES
        }
      },
      {
        name: I18n.tr('menu.order.restaurant_menu.menus'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.MENUS
        }
      },
      {
        name: !_.isNull(this.menu) ? this.menu.name : '',
        link: null
      }
    ];

    return (
      <div className="menu_detail_page">
        <Ariane icon={arianeIcon} details={arianeDetails} />
        {this.renderBody()}
        {this.renderLoading()}
      </div>
    );
  }

}

export default MenuDetailPage;
